import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToastSlice } from '@hcs/toast';
import { Account } from '@hcs/types';

import { AuthApi } from '../api';

const QUERY_KEY_CHECK_RESET_PASSWORD_TOKEN = 'check-reset-password-token';

type ErrorResponse = AxiosError<{
  message: string;
}>;
export const useCheckResetPasswordToken = (
  token?: string | null,
  options?: UseQueryOptions<Account, ErrorResponse>
) => {
  const {
    actions: { toastOpen },
  } = useToastSlice();
  return useQuery<Account, ErrorResponse>(
    [QUERY_KEY_CHECK_RESET_PASSWORD_TOKEN, token],
    async () => {
      if (token) {
        return await AuthApi.checkResetPasswordToken(token);
      } else {
        // Should never get here because of enabled option below
        throw new Error('[Check Reset Password Token] No Token to Check');
      }
    },
    {
      enabled: !!token,
      onError: (error) => {
        toastOpen({
          type: 'error',
          title:
            error.response?.data.message === 'expired'
              ? 'Email link has expired, resend email'
              : error.response?.data.message || '',
        });
        options?.onError?.(error);
      },
    }
  );
};
